import type { SVGProps } from 'react'
const SvgSyDesk = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillOpacity={0.24}
			fillRule="evenodd"
			d="M8 5.309c0-.144 0-.216-.045-.26s-.117-.042-.26-.038c-1.053.03-1.678.143-2.11.575C5 6.172 5 7.114 5 9v7c0 1.886 0 2.828.586 3.414S7.114 20 9 20h6c1.886 0 2.828 0 3.414-.586S19 17.886 19 16V9c0-1.886 0-2.828-.586-3.414-.431-.432-1.056-.545-2.11-.575-.142-.004-.213-.006-.258.038s-.046.116-.046.26V6.5a1.5 1.5 0 0 1-3 0V5.3c0-.141 0-.212-.044-.256S12.841 5 12.7 5h-1.4c-.141 0-.212 0-.256.044S11 5.159 11 5.3v1.2a1.5 1.5 0 0 1-3 0z"
			clipRule="evenodd"
		/>
		<path d="M9.5 3a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5m5 0a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5m-5 7a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0 3a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5zm0 3a.5.5 0 0 0-.5.5.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5.5.5 0 0 0-.5-.5z" />
	</svg>
)
export default SvgSyDesk
